// extracted by mini-css-extract-plugin
export default {"feed":"style_feed__s4oz5"};